/* Actions */
import {ActionTypes} from '../store/user/user-actions';

/* eslint-disable */
export function startSdkHelpers(store) {
  if (window.DashboardComponent) {
    window.DashboardComponent._userSession.on('OrganizationChange', (organization) => {
      store.dispatch({type: ActionTypes.HANDLE_ORGANIZATION_CHANGE, organization});
    });
  }
}

export function steveDataStorage(rootName, key, includeOrganization = false) {
  const storageFactory = Steve.di.getRegistered('$teve.storageFactory').registeredObj;
  const dataStorage = storageFactory.getRemoteStorageInstance(rootName, key);
  let organizationId = null;
  if (
    window.DashboardComponent._userSession &&
    window.DashboardComponent._userSession &&
    window.DashboardComponent._userSession._activeOrganization &&
    window.DashboardComponent._userSession._activeOrganization.id
  ) {
    organizationId = window.DashboardComponent._userSession._activeOrganization.id;
  }
  return {
    get: (dataKey, ignoreSession = true) => {
      if (includeOrganization && organizationId) {
        try {
          let storage = storageFactory.getRemoteStorageInstance(rootName, key);
          const data = storage.getData(dataKey, ignoreSession);
          return data[organizationId];
        } catch (e) {
          return false;
        }
      } else {
        try {
          return dataStorage.getData(dataKey, ignoreSession);
        } catch (e) {
          return false;
        }
      }
    },
    set: (data, dataKey) => {
      if (includeOrganization) {
        let storage = storageFactory.getRemoteStorageInstance(rootName, key);
        const oldData = storage.getData(dataKey, true);
        const newData = {
          ...oldData,
          [organizationId]: data,
        };
        dataStorage.setData(newData, dataKey);
      } else {
        try {
          dataStorage.setData(data, dataKey);
        } catch (e) {
          return false;
        }
        dataStorage.setData(data, dataKey);
      }
    },
    setByOrgId: (data, dataKey, orgId) => {
      let storage = storageFactory.getRemoteStorageInstance(rootName, key);
      const oldData = storage.getData(dataKey, true);
      const newData = {
        ...oldData,
        [orgId]: data,
      };
      dataStorage.setData(newData, dataKey);
    },
    remove: (dataKey) => {
      try {
        dataStorage.removeData(dataKey);
      } catch (e) {
        return false;
      }
    },
  };
}

/* eslint-enable */
export default startSdkHelpers();
